import state from './state';
import mutations from './mutations';
import { OverlayState } from '@/store/overlays/types';
import { Module } from 'vuex';
import { State } from '@/store/play-root-state';

export default <Module<OverlayState, State>>{
    namespaced: true,
    state,
    mutations,
};
